import React from 'react';
import './Services.css';
import { FaMobileAlt, FaLaptopCode, FaBullhorn } from 'react-icons/fa';

const Services = () => {
    return (
      <section className="services-section" id="services">
        <div className="services-header">
          <h2>Our <span>Services</span></h2>
          <p>We offer creative and scalable digital solutions tailored to your business needs.</p>
        </div>
  
        <div className="services-wrapper">
          {/* App Development */}
          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="icon-box"><FaMobileAlt /></div>
                <h3>App Development</h3>
                <p>
                  Build high-performance mobile applications for iOS & Android using modern frameworks and native technologies.
                </p>
              </div>
              <div className="flip-card-back">
                <h4>Curious how we did it?</h4>
                <a href="/projects?category=app" className="see-projects-btn">Explore Projects</a>
              </div>
            </div>
          </div>
  
          {/* Web Development */}
          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="icon-box"><FaLaptopCode /></div>
                <h3>Web Development</h3>
                <p>
                  Responsive websites powered by the latest tech. Specialized in Shopify and Squarespace for seamless eCommerce.
                </p>
              </div>
              <div className="flip-card-back">
                <h4>See our web magic?</h4>
                <a href="/projects?category=web" className="see-projects-btn">Explore Projects</a>
              </div>
            </div>
          </div>
  
          {/* Digital Marketing */}
          <div className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <div className="icon-box"><FaBullhorn /></div>
                <h3>Digital Marketing</h3>
                <p>
                  Grow your brand with SEO, PPC, email campaigns, and social media strategies that drive real results.
                </p>
              </div>
              <div className="flip-card-back">
                <h4>Wanna see real growth?</h4>
                <a href="/projects?category=marketing" className="see-projects-btn">Explore Projects</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

export default Services;
